function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.106 0h12.739c.072 0 .134.047.15.116a.143.143 0 01-.084.164c-1.249.56-1.952 1.875-1.952 3.047v12.525a.676.676 0 01-.238.53L7.397 21.8a.826.826 0 01-1.083-.005L.232 16.382A.677.677 0 010 15.858V2.939C0 1.321 1.396 0 3.106 0z",
  fill: "url(#primary-badge_svg__a)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 10l3.95-4.95L10.9 10l-3.95 4.95L3 10z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "primary-badge_svg__a",
  x1: 0,
  y1: 22,
  x2: 20.93,
  y2: 6.778,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB77C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E95F48"
})));

function SvgPrimaryBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 22",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "primary-badge-28fea1d4eee98a14cab3957c9aa3014a.svg";
export { SvgPrimaryBadge as ReactComponent };